import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import PinModal from "components/__new/common/PinModal";
import Maybe from "components/__new/common/Maybe";
import useLoginInfo from "hooks/useLoginInfo";
import ModalAlert from "components/__new/common/ModalAlert";
import maskEmailAddress from "utils/maskData";
import useAccessPinStatus from "hooks/useAccessPinStatus";
import * as walletAction from "store/entities/wallet/action";
import { useLocation } from "react-router-dom";
import AirtimeTransactionsTable from "components/__new/billPayment/airtime/AirtimeTransactionsTable";
import AirtimePurchaseType from "components/__new/billPayment/airtime/AirtimePurchaseType";
import { airtimePurchaseMultiple, airtimePurchaseReset, airtimePurchaseSingle, clearAirtimePreviewItems, getAirtimeTransactions } from "store/entities/billPayment/action";
import MultipleAirtimePurchaseAmountSetup from "components/__new/billPayment/airtime/MultipleAirtimePurchaseAmountSetup";
import useBillPaymentUserId from "hooks/useBillPaymentUserId";
import BulkAirtimeReviewModal from "components/__new/billPayment/airtime/BulkAirtimeReviewModal";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import processParams from "utils/processParams";
import BillPaymentsInlineRouter from "./BillPaymentsInlineRouter";
import * as notificationAction from "store/entities/notification/action"
import * as billPaymentAction from "store/entities/billPayment/action"
import { REGEX_VALUES } from 'utils/regexValues';
import { WorkflowType } from "utils/workflowType";



export const AirtimeTransactions = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {userInfo, updateIsAccessPinSet} = useLoginInfo();
    const {billPaymentUserId} = useBillPaymentUserId();
    const {getAccessPinStatus} = useAccessPinStatus();
    const {urlQueryParams} = useUrlQueryParams();
    const { dashboardLoading, dashboard, otpGenerationLoading, otpGeneration, accessPinLoading, accessPin } = useSelector((s) => s.entities.wallet);    
    const { airtimePurchaseLoading, airtimePurchase, createBeneficiary, airtimeTransactionsLoading, airtimeTransactionsData } = useSelector((s) => s.entities.billPayment);    

    const airtimeTabItems = [
        { title: "Single Purchase", value: "single" },
        { title: "Multiple Purchase", value: "multiple", disabled: true, },
        { title: "Bulk Upload", value: "bulk", disabled: true, }
    ]
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    
    const [airtimePurchaseType, setAirtimePurchaseType] = useState("single");
    const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);
    
    const [isOpenOtpNewPin, setIsOpenOtpNewPin] = useState(false);
    const [isOpenAccessPin, setIsOpenAccessPin] = useState(false);
    const [isOpenNewAccessPin, setIsOpenNewAccessPin] = useState(false);
    
    const [transferPayload, setTransferPayload] = useState(null);
    const [beneficiaryName, setBeneficiaryName] = useState("");
    const [previewItems, setPreviewItems] = useState([]);
    
    const [isOpenConfirmAccessPin, setIsOpenConfirmAccessPin] = useState(false);
    const [isModalAlertSuccessOpen, setIsModalAlertSuccessOpen] = useState(false);
    const [isOpenModalAlertTransferSuccess, setIsOpenModalAlertTransferSuccess] = useState(false);
    const [isOpenModalAlertNewPinSuccess, setIsOpenModalAlertNewPinSuccess] = useState(false);
    const [isAirtimeReviewOpen, setIsAirtimeReviewOpen] = useState(false);
    
    const [airtimePreviewItems, setAirtimePreviewItems] = useState([]);
    const [isAmountSetupOpen, setIsAmountSetupOpen] = useState(false);
    const [isSavingBeneficiary, setIsSavingBeneficiary] = useState(false);
    const [selectSingleBeneficiary, setSelectSingleBeneficiary] = useState({});
    const [isBeneficiaryCreated, setIsBeneficiaryCreated] = useState(false);
    
    const toggleAirtimeReview = () => setIsAirtimeReviewOpen(!isAirtimeReviewOpen)
    const togglePurchaseModal = () => setIsPurchaseModalOpen(!isPurchaseModalOpen);
    const toggleAmountSetup = () => setIsAmountSetupOpen(!isAmountSetupOpen)
    
    const [pin, setPin] = useState({
        otp: "",
        accessPin: "",
        accessPinConfirm: "",
    })


    const getDashboard = () => {
        if(!dashboardLoading && (Object.keys(dashboard).length === 0 || dashboard.status !== "success")){
            dispatch(walletAction.getDashboardSilent(userInfo.token));
        }
    }

    const resetPins = () => {
        setPin({ ...pin, otp: "", accessPin: "", accessPinConfirm: "" });
    }

    const initiatePurchase = (payload) => {

        if(!dashboard?.data) {
            toast.error("Unable to procees transaction: wallet details not found")
        } else {

            resetPins();
            setTransferPayload(payload);
            const hasAccessPin = getAccessPinStatus(dashboard);

            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenNewAccessPin(true);
            }
            else if (hasAccessPin === true){
                setIsOpenAccessPin(true);
            } 
            // if(hasAccessPin){
            //     setIsOpenAccessPin(true)
            // } else {
            //    setIsOpenNewAccessPin(true);

            // }
        }
    }
    
    const processAirtimePurchase =() => {
            
            if(airtimePurchaseType === WorkflowType.BILL_PAYMENT_REQUEST || airtimePurchaseType === "single") {
                dispatch(airtimePurchaseSingle({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }))
                dispatch(notificationAction.getAllNotifications());
            } else if(airtimePurchaseType === WorkflowType.MULTIPLE_BILL_PAYMENT_REQUEST || airtimePurchaseType === "multiple") {
                dispatch(airtimePurchaseMultiple({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
                dispatch(notificationAction.getAllNotifications());
            } else if(airtimePurchaseType === 'bulk') {
                dispatch(airtimePurchaseMultiple({
                    ...transferPayload,
                    accessPin: pin.accessPin
                }));
                dispatch(notificationAction.getAllNotifications());
            }
    }
    
    const handleNameChange = (e) => {
        const { value } = e.target;
        if ((!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AMPERSAND_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
          return;
        }
        setBeneficiaryName(value)
      }
    
    
    const handleCreateBeneficiary = () => {
        const  user = selectSingleBeneficiary
        
        
        // if(!beneficiaryName?.length) {
        //     toast.error("Please enter a beneficiary name")
        // } else {
            if(airtimePurchaseType === 'single') {
                dispatch(billPaymentAction.createBeneficiary({
                    businessId: userInfo?.employer?._id,
                    service: 'airtime',
                    phoneNumber: user?.phoneNumber,
                    alias: beneficiaryName || '-',
                    product: transferPayload?.service,
                }))
                setIsBeneficiaryCreated(true);
            } else if(airtimePurchaseType === 'multiple') {
            // 
            }
        // }
        
    }
    
        
    useEffect(() => {
        if(createBeneficiary?.status === "success" && isBeneficiaryCreated === true) {
            toast(createBeneficiary?.message)
            setIsBeneficiaryCreated(false);
            setIsOpenModalAlertTransferSuccess(false)
        }
        // eslint-disable-next-line
    }, [createBeneficiary]);

    
    
    const defaultParams = {
        channel: "web",
        // userId: billPaymentUserId,
        businessId: billPaymentUserId,
    }
    
    
    const generateClientReference = (phoneNumber) => {
        const date = Date.parse(new Date());
        const clientReference = userInfo?.employer?.firstName.charAt(0) + userInfo?.employer?.lastName.charAt(0) + date + phoneNumber;
        return (clientReference);
    }
    
    const getTransactions = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange");
        params = processParams(urlQueryParams, params, "biller", "string", "", "biller");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(getAirtimeTransactions({
            businessId: userInfo.employer._id,
            ...params
        }));
    }

    useEffect(() => {
        getTransactions();
        // eslint-disable-next-line
    }, [location]);
    
    
    useEffect(() => {
        if (airtimePurchase?.status === "success" || airtimePurchase?.message === "Successful"){
            setIsOpenModalAlertTransferSuccess(true);
            setIsOpenAccessPin(false);
            dispatch(airtimePurchaseReset());
            dispatch(clearAirtimePreviewItems());
            getTransactions();
            dispatch(notificationAction.getAllNotifications());
        }
        else if (airtimePurchase?.status === "failed"){
            dispatch(airtimePurchaseReset());
            dispatch(notificationAction.getAllNotifications())
        }
        else if (airtimePurchase?.status === "pending"){
            toast.error(airtimePurchase?.message);
            dispatch(airtimePurchaseReset());
        }
        // eslint-disable-next-line
    }, [airtimePurchase])
    

    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line
    }, [])

    // Check the success of the otp generation
    useEffect(() => {
        // if (otpGeneration?.status === "success"){
        if (otpGeneration?.error === false){
            const hasAccessPin = getAccessPinStatus(dashboard);
            if (hasAccessPin === null || hasAccessPin === false){
                setIsOpenConfirmAccessPin(false);
                setIsOpenOtpNewPin(true);
            }
            dispatch(walletAction.generateOtpReset());
        }
        // eslint-disable-next-line
    }, [otpGeneration])


    useEffect(() => {
        if (accessPin?.error === false){
            setIsOpenOtpNewPin(false);
            setIsOpenModalAlertNewPinSuccess(true);
            resetPins();
            dispatch(walletAction.createAccessPinReset());
            dispatch(walletAction.getDashboard(userInfo));
            // updateIsAccessPinSet(true);
        }
        // eslint-disable-next-line
    }, [accessPin])


    return (
        <div>

            <DynamicHeadTag
                headerText="Buy Airtime - Recharge Airtime"
            />
            
            <BulkAirtimeReviewModal
                isOpen={isAirtimeReviewOpen}
                togglePurchaseModal={togglePurchaseModal}
                toggleAirtimeReview={toggleAirtimeReview}
                generateClientReference={generateClientReference}
                defaultParams={defaultParams}
                initiatePurchase={initiatePurchase}
            />
            
            <AirtimePurchaseType
                airtimePreviewItems={airtimePreviewItems}
                isOpen={isPurchaseModalOpen}
                setAirtimePreviewItems={setAirtimePreviewItems}
                initiatePurchase={initiatePurchase}
                setAirtimePurchaseType={setAirtimePurchaseType}
                toggleAirtimeReview={toggleAirtimeReview}
                airtimeTabItems={airtimeTabItems}
                togglePurchaseModal={togglePurchaseModal}
                toggleAmountSetup={toggleAmountSetup}
                previewItems={previewItems}
                setPreviewItems={setPreviewItems}
                generateClientReference={generateClientReference}
                defaultParams={defaultParams}
                selectSingleBeneficiary={selectSingleBeneficiary}
                setSelectSingleBeneficiary={setSelectSingleBeneficiary}
            />
            
            <Maybe condition={isAmountSetupOpen}>
                <MultipleAirtimePurchaseAmountSetup
                    previewItems={previewItems}
                    setPreviewItems={setPreviewItems}
                    isOpen={isAmountSetupOpen}
                    togglePurchaseModal={togglePurchaseModal}
                    toggleAmountSetup={toggleAmountSetup}
                    initiatePurchase={initiatePurchase}
                    generateClientReference={generateClientReference}
                    defaultParams={defaultParams}
                />
            </Maybe>
            
            <BillPaymentsInlineRouter />

            <Maybe condition={dashboard?.status === "success"}>
                <>

                    <PinModal
                        target="Access Pin"
                        title="Validate Payment"
                        description="Enter Transaction Pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={processAirtimePurchase}
                        loading={airtimePurchaseLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenAccessPin}
                        setIsOpenPin={setIsOpenAccessPin}
                        showForgotPin={true}
                    />


                    <ModalAlert
                        successText="Congratulations! Your transaction was successful"
                        dismissText="Close"
                        isOpenModalAlert={isOpenModalAlertTransferSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertTransferSuccess}
                        showSwitch={airtimePurchaseType === 'single'}
                        switchTitle="Save as beneficiary"
                        switchSubtitle="You can save these details for later use"
                        onSwitchChange={() => setIsSavingBeneficiary(!isSavingBeneficiary)}
                        isSwitchActive={isSavingBeneficiary}
                        hideSwitchLabel
                        showInputField={isSavingBeneficiary}
                        inputFieldLabel="Beneficiary Name"
                        inputFieldPlaceholder="Enter beneficiary name"
                        inputFieldButtonText="Save"
                        onInputFieldChange={handleNameChange}
                        inputFieldOnSubmit={handleCreateBeneficiary}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Create Access Pin"
                        description="Set new access pin"
                        pin={(e) => setPin({...pin, accessPin: e})}
                        submit={() => {
                            setIsOpenNewAccessPin(false);
                            setIsOpenConfirmAccessPin(true);
                        }}
                        loading={false}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenNewAccessPin}
                        setIsOpenPin={setIsOpenNewAccessPin}
                    />


                    <PinModal
                        target="Access Pin"
                        title="Confirm Access Pin"
                        description="Please re-enter your access pin"
                        pin={(e) => setPin({...pin, accessPinConfirm: e})}
                        submit={() => {
                            if (pin.accessPin === pin.accessPinConfirm){
                                if (userInfo.employer.userType === "employer"){
                                    dispatch(walletAction.generateOtpWithId(userInfo.token, {otpType: "access-pin", userId: userInfo.employer._id}));
                                }
                                else if (userInfo.employer.userType === "employer-admin" || userInfo.employer.userType === "employer-business-member"){
                                    dispatch(walletAction.generateOtpEmployerAdmin(null, 'access-pin'));
                                }
                            }
                            else{
                                toast.error("Your access pin does not match");
                            }
                        }}
                        loading={otpGenerationLoading}
                        modalLoading={dashboardLoading}
                        isOpenPin={isOpenConfirmAccessPin}
                        setIsOpenPin={setIsOpenConfirmAccessPin}
                    />


                    <PinModal
                        target="OTP"
                        title="Enter OTP"
                        description={"Enter OTP sent to " + maskEmailAddress(userInfo?.member?.email) + ", to create your new access pin"}
                        pin={(e) => setPin({...pin, otp: e})}
                        submit={() => {
                            const params = {otp: parseInt(pin.otp), accessPin: pin.accessPin}
                                dispatch(walletAction.createAccessPin(userInfo.token, params));
                        }}
                        loading={accessPinLoading}
                        modalLoading={otpGenerationLoading}
                        isOpenPin={isOpenOtpNewPin}
                        setIsOpenPin={setIsOpenOtpNewPin}
                    />


                    <ModalAlert
                        successText="Access Pin created successfully"
                        dismissText="Back to bills payment"
                        isOpenModalAlert={isOpenModalAlertNewPinSuccess}
                        setIsOpenModalAlert={setIsOpenModalAlertNewPinSuccess}
                        submit={() => {
                            setIsOpenModalAlertNewPinSuccess(false);
                            setIsOpenAccessPin(true);
                        }}
                    />
                    
                </>
            </Maybe>
            
            <AirtimeTransactionsTable
                loading={airtimeTransactionsLoading}
                data={airtimeTransactionsData}
                togglePurchaseModal={togglePurchaseModal}
            />

        </div>
    )
}


export default AirtimeTransactions;
